import React from 'react';
import styled from 'styled-components';
import { FlexContainer } from '../../../styled/layout.styled';
import { Caption } from '../../../styled/typograpghy.styled';
import RelativeLink from '../../../../components/RelativeLink/RelativeLink';

const StyledPaidAffiliate = styled.h3`
  color: #22096c;
  margin: 0 0 8px 0;
  @media only screen and (max-width: 568px) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const StyledGetYourProfit = styled.h1`
  color: #22096c;
  margin: 0;
  @media only screen and (max-width: 568px) {
    font-size: 34px;
    line-height: 42px;
  }
`;

const StyledCaption = styled(Caption)`
  color: #1f0d53;
  margin: 18px 0 32px 0;
  @media only screen and (max-width: 568px) {
    margin: 16px 0 24px 0;
  }
`;

export const StyledButton = styled(
  ({
    width, margin, backgroundColor, borderColor, color, hoverColor, hoverBackgroundColor, ...rest
  }) => (
    <RelativeLink {...rest} />
  )
)`
  width: ${({ width = '240px' }) => width};
  height: 50px;
  border-radius: 4px;
  margin: ${({ margin }) => margin};
  background-color: ${({ backgroundColor = '#ff2976' }) => backgroundColor};
  border: ${({ borderColor }) => `solid 1px ${borderColor}`};
  color: ${({ color = '#ffffff' }) => color};
  padding: 13px;
  text-align: center;
  @media only screen and (max-width: 568px) {
    width: 100%;
    margin: ${({ mobileMargin }) => mobileMargin};
  }
  link {
    text-align: center;
    text-decoration: none;
  }
  &:hover {
    color: ${({ hoverColor = '#fff' }) => hoverColor};
    background-color: ${({ hoverBackgroundColor = '#d10a52' }) => hoverBackgroundColor};
  }
  transition: all 0.3s ease;
`;

const PaidAffiliate = () => (
  <>
    <FlexContainer
      flexDirection="column"
      width="50%"
      tabletWidth="100%"
      padding="113px 0 0 0"
      tabletPadding="70px 0"
      mobilePadding="37px 0 32px 0"
    >
      <StyledPaidAffiliate>HIGHEST PAID COMMISSIONS</StyledPaidAffiliate>
      <StyledGetYourProfit>INSTANT PROFITS IN REAL-TIME</StyledGetYourProfit>
      <StyledCaption className="xlarge">
        Refer your audience to Peergame and earn real-time profits without any withdrawal process. Start your lifetime
        wager(not revenue) share today!
      </StyledCaption>
      <FlexContainer mobileFlexDirection="column">
        <StyledButton
          to="/dashboard"
          margin="0 20px 0 0"
          backgroundColor="#F8F5FF"
          borderColor="#c7baf1"
          color="#6e658a"
          hoverColor="#6e658a"
          hoverBackgroundColor="#F0ECFF"
          mobileMargin="0 0 20px 0"
        >
          DASHBOARD
        </StyledButton>
        <StyledButton to="/registration">BECOME A PARTNER</StyledButton>
      </FlexContainer>
    </FlexContainer>
  </>
);

export default PaidAffiliate;
